//プロパティactiveIdxが変更された際に実行する関数
export function changeActive(oldValue, value) {
    const oldActiveElements = document.querySelectorAll(`[data-chara-idx="${oldValue}"]`) || 0;
    if (oldActiveElements.length) {
        oldActiveElements.forEach((el) => {
            el.classList.remove('-active');
        });
    }

    const newActiveElements = document.querySelectorAll(`[data-chara-idx="${value}"]`);
    newActiveElements.forEach((el) => {
        el.classList.add('-active');
    });
    history.replaceState(null, null, `?characterIdx=${value}`);
}
